import React from 'react'

import { useCampaignBanners, useCreateBanners } from 'hooks/useCampaignBanners'
import type { BannerType } from 'models/campaign-banners-model'

import CampaignBannerUpload from './CampaignBannerUpload'

type CampaignBannerCreateProps = {
  customerId: number
  id: string
  open: boolean
  type: BannerType
  onClose: (...args: any[]) => any
}

const CampaignBannerCreate = ({ customerId, id, open, type, onClose }: CampaignBannerCreateProps) => {
  const createBanners = useCreateBanners()
  const { data: existingBanners = [] } = useCampaignBanners(id)

  return (
    <CampaignBannerUpload
      existingBanners={existingBanners}
      initialValues={{ customerId, banners: [], type }}
      name="banners"
      onClose={onClose}
      onSubmit={(banners: any) => createBanners(id, banners)}
      open={open}
      title="Upload new banners"
    />
  )
}

export default CampaignBannerCreate
